/**
 * @fileoverview POST handler for the "/generative_ai/variant_generation_assistant" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { generativeAiVariantGenerationAssistantCacheKeys } from "./constants";
import type { PostGenerativeAiVariantGenerationAssistantProps, GeneratedComponentsResponse } from "./types";

export const postGenerativeAiVariantGenerationAssistant = reactQueryMutationAdapter(
  generativeAiVariantGenerationAssistantCacheKeys,
  (props: PostGenerativeAiVariantGenerationAssistantProps): Promise<GeneratedComponentsResponse> => {
    // manipulate props here as needed { message, count, message_ty[e }

    return fetch("/generative_ai/variant_generation_assistant", "POST", props, undefined, {
      // don't display a modal on fetch errors
      propagateFetchRequestError: false,
    });
  }
);
